import type { AnalyticsSensitivity } from '../../types/analytics-controls.types';

import { AnalyticsHealthSummary } from './analytics-health-summary';
import { ExperimentAdjustedMetrics } from './experiment-adjusted-metrics';
import { ExperimentCategoryExclusions } from './experiment-category-exclusions';
import { ExperimentInStockTrends } from './experiment-in-stock-trends';

interface Props {
  experimentId: string;
  /** Fixed outlier sensitivity (drives the analytics summary card). */
  sensitivity: AnalyticsSensitivity;
}

export function ExperimentHealthTab({ experimentId, sensitivity }: Props) {
  return (
    <div className="space-y-6">
      <AnalyticsHealthSummary experimentId={experimentId} sensitivity={sensitivity} />
      <ExperimentInStockTrends experimentId={experimentId} />
      <ExperimentCategoryExclusions experimentId={experimentId} />
      <ExperimentAdjustedMetrics experimentId={experimentId} />
    </div>
  );
}
